var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name === 'contact-list')?_c('ContactFolderList'):_c('MailFolderList')}
var staticRenderFns = []

export { render, staticRenderFns }